import { render, staticRenderFns } from "./ReservationInfo.vue?vue&type=template&id=f4a8faea&"
import script from "./ReservationInfo.vue?vue&type=script&lang=js&"
export * from "./ReservationInfo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)


    import installComponents from "!/builds/rentmagic/rentmagic.website.vue.west-vlaanderen/node_modules/bootstrap-vue-loader/lib/runtime/installComponents.js"
    import {BCard} from 'bootstrap-vue'
    installComponents(component, {BCard})
    

export default component.exports